// src/helpers/winbackHelper.js
import { get, post, patch } from './apiHelper';

const winbackHelper = {
    // Configuración
    getConfig: async (marcaId) => {
        try {
            return await get(`marcas/${marcaId}/winback-config`);
        } catch (error) {
            if (error.status === 404) {
                return null; // No hay configuración aún
            }
            throw error;
        }
    },

    updateConfig: async (marcaId, config) => {
        return await patch(`marcas/${marcaId}/winback-config`, config);
    },

    // Clientes Inactivos
    getInactiveCustomers: async (options = {}) => {
        const params = new URLSearchParams();
        if (options.useIntelligent !== undefined) {
            params.append('useIntelligent', options.useIntelligent);
        }
        if (options.threshold) {
            params.append('threshold', options.threshold);
        }
        const queryString = params.toString();
        const url = `clientes/winback/inactive${queryString ? `?${queryString}` : ''}`;
        return await get(url);
    },

    // Recomendaciones
    getRecommendation: async (clienteId) => {
        return await get(`clientes/winback/recommendation/${clienteId}`);
    },

    // Envío
    sendWinback: async (clienteId, options = {}) => {
        return await post(`clientes/winback/send/${clienteId}`, {
            channel: 'email',
            ...options
        });
    },

    sendBatch: async (clienteIds, options = {}) => {
        return await post('clientes/winback/batch', {
            clienteIds,
            channel: 'email',
            ...options
        });
    },

    // Estadísticas
    getStats: async (marcaId) => {
        return await get(`clientes/winback/stats/${marcaId}`);
    },

    // Campañas
    getCampaigns: async (options = {}) => {
        const params = new URLSearchParams();
        if (options.marcaId) {
            params.append('marcaId', options.marcaId);
        }
        if (options.status) {
            params.append('status', options.status);
        }
        const queryString = params.toString();
        const url = `clientes/winback/campaigns${queryString ? `?${queryString}` : ''}`;
        return await get(url);
    }
};

export default winbackHelper;

